import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getMaterials(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: id
        description: name
      }
      recordCount
    }
  }
`;

export const useGetMaterialsAsOptionsQuery = () => {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
};

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
  production?: boolean;
}

export const FieldSelectMaterial = ({
  label = 'Απόβλητο',
  name = 'materialId',
  defaultValues = {},
  size = 'sm',
  production = false,
  ...rest
}: LcFsProps) => {
  const where = JSON.stringify({
    useInProduction: production ? 1 : 0,
    isActive: 1,
  });
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetMaterialsAsOptionsQuery}
      height={size === 'lg' ? 32 : '22'}
    />
  );
};

// export const FieldSelectMaterialPress = ({
//   label = 'Απόβλητο',
//   name = 'matGuid',
//   defaultValues = {},
//   size = 'sm',
//   where = pressMaterialsWhere,
//   ...rest
// }: LcFsProps) => {
//   return <FieldSelectMaterial {...rest} label={label} name={name} where={where} />;
// };

// export const FieldSelectMaterialDelivery = ({
//   label = 'Απόβλητο',
//   name = 'matGuid',
//   defaultValues = {},
//   size = 'sm',
//   where = deliveryMaterialsWhere,
//   ...rest
// }: LcFsProps) => {
//   return <FieldSelectMaterial {...rest} label={label} name={name} where={where} />;
// };

